import { useEffect, useRef } from 'react'

const useWebsocket = ({ url, onMessage, onError, onClose }) => {
  const websocketRef = useRef(null)
  const callbacksRef = useRef({ onMessage, onError, onClose })

  useEffect(() => {
    callbacksRef.current = { onMessage, onError, onClose }
  })

  useEffect(() => {
    if (!url) return

    const websocket = new WebSocket(url)
    websocketRef.current = websocket

    websocket.onmessage = event => {
      if (websocketRef.current !== websocket) return

      callbacksRef.current.onMessage?.(JSON.parse(event.data))
    }

    websocket.onerror = () => {
      websocketRef.current = null
      websocket.close()
      callbacksRef.current.onError?.()
    }

    websocket.onclose = () => {
      if (websocketRef.current !== websocket) return

      websocketRef.current = null
      callbacksRef.current.onClose?.()
    }

    return () => {
      websocketRef.current = null
      websocket.close()
    }
  }, [url])

  const close = () => {
    websocketRef.current?.close()
    websocketRef.current = null
  }

  return { close }
}

export default useWebsocket
